import { Body, ContainerLogo, ContainerMain, Form, Header } from '../home/style';
import { BavyroxLogo } from '../../assets';
import { BackButton, ButtonForm, Check, Input } from '../../components';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { errorMessages, validation } from '../../validations';
import { Step3Props } from './types';
import { useState, useCallback } from 'react';
import Terms from '../home/terms';
import { toast } from 'react-toastify';

const SUBMITTED_EMAILS_KEY = 'bavyrox_submitted_emails';

export default function Step3(props: Step3Props) {
  const { option, onSubmit, onBack } = props;
  const [isError,] = useState(false);
  const [errorName, setErrorName] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [isCheking,] = useState(false);
  const [isAcceptTerm, setIsAcceptTerm] = useState(true);
  const [isOpenTerm, setIsOpenTerm] = useState(false);
  const [isOpenTootip, setIsOpenTootip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isEmailAlreadySubmitted = useCallback((email: string): boolean => {
    try {
      const stored = localStorage.getItem(SUBMITTED_EMAILS_KEY);
      const emails: string[] = stored ? JSON.parse(stored) : [];
      return emails.includes(email.toLowerCase().trim());
    } catch {
      return false;
    }
  }, []);

  const markEmailAsSubmitted = useCallback((email: string) => {
    try {
      const stored = localStorage.getItem(SUBMITTED_EMAILS_KEY);
      const emails: string[] = stored ? JSON.parse(stored) : [];
      emails.push(email.toLowerCase().trim());
      localStorage.setItem(SUBMITTED_EMAILS_KEY, JSON.stringify(emails));
    } catch {}
  }, []);

  const {
    control,
    register,
    formState: { errors },
    setFocus,
  } = useForm({
    resolver: yupResolver(validation),
    defaultValues: { option },
    mode: 'onBlur',
  });
  const data = useWatch({ control });

  const handleOpenTerms = () => {
    setIsOpenTerm(true);
    setIsAcceptTerm(true);
  };

  const handleSubmit = async () => {
    setTimeout(() => {
      setIsOpenTootip(false);
      setErrorName('');
      setErrorEmail('');
    }, 1500);

    setErrorName('');
    setErrorEmail('');
    if (!data.name) setErrorName(errorMessages.name.required);
    if (!data.email) setErrorEmail(errorMessages.email.required);
    if (!data.name && !data.email) {
      setFocus('name');
    }
    if (!isAcceptTerm) {
      setIsOpenTootip(true);
      return;
    }
    setIsOpenTootip(false);

    if (
      data.email &&
      data.name &&
      !errors.email?.message &&
      !errors.name?.message
    ) {
      if (isEmailAlreadySubmitted(data.email)) {
        toast.warn('Este e-mail já foi cadastrado. Use outro e-mail.');
        setErrorEmail('Este e-mail já foi cadastrado.');
        return;
      }

      setIsLoading(true);
      try {
        markEmailAsSubmitted(data.email);
        await onSubmit(data, !isError);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const onFocus = () => {
    if (!!errors.name?.message || !data.name) {
      setFocus('name');
      return;
    }
    if (!!errors.email?.message || !data.email) {
      setFocus('email');
      return;
    }
    if(!data.name && !data.email) {
      setFocus('name');
    }
  };

  const onBlur = () => {
    setErrorName('');
    setErrorEmail('');
    onFocus();
  };

  return (
    <ContainerMain>
      {onBack && <BackButton onClick={onBack} />}
      <ContainerLogo>
        <img src={BavyroxLogo} alt='logo' />
      </ContainerLogo>
      <Header isCompact>
        <div className='info'>
          <p>Encontramos o cartão perfeito para você!</p>
          <span className='center'>
            Preencha seus dados e receba por e-mail o cartão ideal para o seu
            perfil.
          </span>
        </div>
      </Header>
      <Body>
        <Form>
          <Input
            type='text'
            label='Digite seu primeiro nome'
            placeholder='Insira seu nome aqui'
            {...register('name')}
            error={errors?.name?.message || errorName}
            onBlur={onBlur}
          />

          <Input
            type='email'
            label='Digite seu e-mail principal'
            placeholder='Insira seu melhor e-mail aqui'
            {...register('email')}
            error={errors.email?.message || errorEmail}
            isError={isError}
            isCheking={isCheking}
            onBlur={onBlur}
          />

          <div className='form-group'>
            <div className='terms'>
              <Check
                isChecked={isAcceptTerm}
                isOpen={isOpenTootip}
                onClick={() => setIsAcceptTerm(!isAcceptTerm)}
              />
              <span onClick={handleOpenTerms}>
                Ao prosseguir você concorda com os{' '}
                <span>Termos de Serviço</span>
              </span>
            </div>
          </div>
          <div className='form-group'>
            <ButtonForm type='button' onClick={handleSubmit} isLoading={isLoading} disabled={isLoading} />
          </div>
          {isOpenTerm && <Terms />}
        </Form>
      </Body>
    </ContainerMain>
  );
}
